/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getJsonType as e, getGeometryType as t } from "../../geometry/support/jsonUtils.js";

function r(t) {
  return {
    geometryType: e(t[0]),
    geometries: t.map(function (e) {
      return e.toJSON();
    })
  };
}

function o(e, r, o) {
  var n = t(r);
  return e.map(function (e) {
    var t = n.fromJSON(e);
    return t.spatialReference = o, t;
  });
}

export { o as decodeGeometries, r as encodeGeometries };